import { render } from "./InstanceStatusPolling.vue?vue&type=template&id=8d00b67c"
import script from "./InstanceStatusPolling.vue?vue&type=script&lang=js"
export * from "./InstanceStatusPolling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__